import React, { useCallback } from 'react';

import { ColourPicker, FontSize, FormWrapper, TextArea, Upload } from '../../../WidgetConfiguratorComponents/FormGroups';
import { IWidgetConfiguratorProps, SettingsChangeObjectFunction } from '../../types/IWidgetBlock';
import { FooterConfigBlockState, FooterSettings } from '../types';

type WidgetConfiguratorProps = IWidgetConfiguratorProps<FooterConfigBlockState>;

const WidgetConfigurator: React.FC<WidgetConfiguratorProps> = ({ viewblockState, setViewblockState }) => {
    const {
        settings: { fontSize, backgroundColor, imageSrc, text, topText, bottomText },
    } = viewblockState;

    const onSettingsChange: SettingsChangeObjectFunction<FooterSettings> = useCallback(
        (params) => {
            setViewblockState((prev) => ({
                ...prev,
                settings: { ...prev.settings, ...params },
            }));
        },
        [setViewblockState]
    );

    const valueText = text?.length ? text : `${topText}\n${bottomText}`;

    return (
        <FormWrapper>
            <FontSize fontSize={fontSize} onChange={(fontSize: number) => onSettingsChange({ fontSize })} />
            <TextArea label='Text' onChange={(text) => onSettingsChange({ text })} value={valueText} />
            <ColourPicker label='Background colour' value={backgroundColor} onChange={(backgroundColor) => onSettingsChange({ backgroundColor })} />
            <Upload label='Upload image' value={imageSrc} onChange={(imageSrc) => onSettingsChange({ imageSrc })} />
        </FormWrapper>
    );
};

export default WidgetConfigurator;
